import { render, staticRenderFns } from "./AddCodewordsModalAdmin.vue?vue&type=template&id=5a0450e2&scoped=true&"
import script from "./AddCodewordsModalAdmin.vue?vue&type=script&lang=js&"
export * from "./AddCodewordsModalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddCodewordsModalAdmin.vue?vue&type=style&index=0&id=5a0450e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0450e2",
  null
  
)

export default component.exports